export enum JobWorkflowMessageType {
  CreateJobSucceeded = 'CreateJob succeeded',
  CancelJobSucceeded = 'CancelJob succeeded',
  CompleteJobSucceeded = 'CompleteJob succeeded',
  RestartJobSucceeded = 'RestartJob succeeded',
  StartJobSucceeded = 'StartJob succeeded',
  StartJobFailed = 'StartJob failed',
}
